<template>
    <v-dialog v-model="modalIsVisible" @click:outside.stop="onClose">
      <v-card v-touch="{ left: () => swipeLeft(), right: () => swipeRight() }">
        <v-img :src="myModalContent" max-height="90vh" max-width="95vw" contain class="grey darken-4">
          <v-layout fill-height>
            <v-row align="center">
              <v-btn icon dark fab right absolute style="top:0px"
                @click="onClose"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
                <v-btn
                  icon absolute left fab dark x-large
                  @click="swipeRight" 
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  icon  absolute right fab x-large dark
                  @click="swipeLeft"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-row>
          </v-layout>
        </v-img>
      </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'ImageDialog',
    props: ['modalIsVisible','modalContent','selectedIndex','images'],
    data: () => ({
      myIndex: 0,
      myModalContent: ""
    }),
    watch: { 
      modalContent: function(newVal) {
          this.myModalContent = newVal;
      }
    },
    methods: {
      swipeLeft() {
        this.myIndex = (++this.myIndex)%this.images.length;
        this.myModalContent = this.images[this.myIndex].src;
      },
      swipeRight() {
        this.myIndex = (--this.myIndex+this.images.length)%this.images.length;
        this.myModalContent = this.images[this.myIndex].src;
      },
      onClose() {
        this.$emit('closedialog');
      }
    }
  }
</script>